// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { MasterReferenceDataResponse } from './master-reference-data-response';

// @ts-ignore
import { ProviderResponse } from './provider-response';

/** See com.rev360.pms.api.controller.patient.implantabledevice.PatientImplantableDeviceResponse */
/* istanbul ignore next */
@GandalfModel
export class PatientImplantableDeviceResponse extends GandalfModelBase {

	@GandalfProperty({ designType: MasterReferenceDataResponse })
	bodyLocation!: MasterReferenceDataResponse | null;

	@GandalfProperty({ designType: String })
	comments!: string | null;

	@GandalfProperty({ designType: Number })
	implantableDeviceId!: number | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	installedDate!: Date | null;

	@GandalfProperty({ designType: Boolean })
	isInstalledDateEstimated!: boolean | null;

	@GandalfConstantDecorator(constants.ImplantableDeviceStatus)
	@GandalfProperty({ designType: constants.ImplantableDeviceStatus })
	status!: constants.ImplantableDeviceStatus | null;

	@GandalfProperty({ designType: ProviderResponse })
	surgeon!: ProviderResponse | null;

	@GandalfProperty({ designType: String })
	udi!: string | null;

}
